import { render, staticRenderFns } from "./DialogAssignCategoria.vue?vue&type=template&id=37373640"
import script from "./DialogAssignCategoria.vue?vue&type=script&lang=js"
export * from "./DialogAssignCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports